import styles from './filterToggle.module.scss';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { safelyParseJSON } from '@/app/helpers/searchparams';
import { FilterOptionKeys } from '@mybestbrands/types';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'next-i18next';

export enum FilterToggleType {
  BUTTON,
  CLEAR,
}

type Props = {
  isActive: boolean;
  filterKey: FilterOptionKeys;
  type: FilterToggleType;
  color?: string;
};

const FilterToggle = ({ isActive, filterKey, type, color = 'black' }: Props) => {
  const { t } = useTranslation('filters');
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  async function toggle() {
    const params = new URLSearchParams(searchParams ?? '');
    const page = params.get('page');
    const filters = params.get('filters');

    const filtersParsed = safelyParseJSON(filters);
    params.set('filters', JSON.stringify({ ...filtersParsed, [filterKey]: !isActive }));

    if (page) params.delete('page');

    const url = `${pathname}?${params.toString()}`;

    router.push(url);
  }

  return (
    <div
      className="position-relative"
      style={{
        zIndex: 2,
      }}>
      <div
        onClick={() => {}}
        key={filterKey}
        className={`${clsx(
          'lowercase d-flex justify-content-center align-items-center pe-4',
          type === FilterToggleType.BUTTON ? 'btn btn-white' : '',
          styles.filter
        )}`}>
        <span className="me-1" style={{ color }}>
          {t(filterKey)}
          <label className={styles.switch}>
            <input type="checkbox" checked={isActive} onChange={toggle} />
            <span className={`${styles['slider']} ${styles['round']}`} />
          </label>
        </span>
      </div>
    </div>
  );
};

export default FilterToggle;
